export default "__VITE_ASSET__n4ad6iaF__"